import BaseLayoutAsync from '../layouts/BaseLayout/BaseLayoutAsync';
import MainAsync from '../pages/Main/MainAsync';
import NavigationAsync from '../components/Navigation/NavigationAsync';
import MobileGameFrameHeaderAsync from '../pages/Game/GameMobile/MobileGameFrameHeader/MobileGameFrameHeaderAsync';
import GameLaunchPreviewMobile from '../components/GameLaunchPreview/GameLaunchPreviewMobile/GameLaunchPreviewMobile';
import ErrorPageAsync from '../pages/ErrorPage/ErrorPageAsync';
import NoContentAsync from '../components/NoContent/NoContentAsync';
import RecentGames from '../components/Games/RecentGames';
import SearchAsync from '../pages/Search/SearchAsync';
import CollectingGamesAsync from '../pages/CollectingGames/CollectingGamesAsync';
import WageringGamesAsync from '../pages/WageringGames/WageringGamesAsync';
import { GameGridItemSkeleton } from '../components/Game/GameGridItem/GameGridItem.skeleton';
import GameGridItem from '../components/Game/GameGridItem/GameGridItem';
import GameIframe from '../components/Game/GameRun/Iframe';
import GameDirectRun from '../components/Game/GameRun/GameDirectRun';
import SpecialOffer from '../pages/SpecialOffer/SpecialOfferAsync';
import SpecialOffers from '../pages/SpecialOffers/SpecialOffersAsync';
import SectionCardsGrid from '../components/SectionCardsGrid/SectionCardsGrid';
import SectionCard from '../components/SectionCardsGrid/SectionCard/SectionCard';
import GameLaunchPreviewDesktop from '../components/GameLaunchPreview/GameLaunchPreviewDesktop/GameLaunchPreviewDesktop';
import GameAsync from '../pages/Game/GameAsync';

import BaseLayoutAsyncSCCOM from '../AppSCCOM/layouts/BaseLayout/BaseLayoutAsync';
import MainAsyncSCCOM from '../AppSCCOM/pages/Main/MainAsync';
import NavigationAsyncSCCOM from '../AppSCCOM/components/Navigation/NavigationAsync';
import MobileGameFrameHeaderAsyncSCCOM from '../AppSCCOM/components/MobileGameFrameHeader/MobileGameFrameHeaderAsync';
import GameLaunchPreviewMobileSCCOM from '../AppSCCOM/components/GameLaunchPreview/GameLaunchPreviewMobile/GameLaunchPreviewMobileAsync';
import ErrorPageAsyncSCCOM from '../AppSCCOM/pages/ErrorPage/ErrorPageAsync';
import NoContentAsyncSCCOM from '../AppSCCOM/components/NoContent/NoContentAsync';
import CategoryDetailsAsync from '../pages/CategoryDetails/CategoryDetailsAsync';
import CategoryDetailsAsyncSCCOM from '../AppSCCOM/pages/CategoryDetails/CategoryDetailsAsync';
import RecentGamesAsyncSCCOM from '../AppSCCOM/pages/RecentGames/RecentGamesAsync';
import SearchAsyncSCCOM from '../AppSCCOM/pages/Search/SearchAsync';
import WageringGamesAsyncSCCOM from '../AppSCCOM/pages/WageringGames/WageringGamesAsync';
import CollectingGamesAsyncSCCOM from '../AppSCCOM/pages/CollectingGames/CollectingGamesAsync';
import { GamesSkeletonItem } from '../AppSCCOM/components/Widgets/GamesWidgetSkeleton';
import GameAsyncSCCOM from '../AppSCCOM/pages/Game/GameAsync';
import SEOWrapper from '../components/SEOWrapper/SEOWrapper';
import SEOWrapperSCCOM from '../AppSCCOM/components/SEOWrapper/SEOWrapper';
import {
  BOUSES_WAGERING_GAMES_NAV_ITEM,
  BONUSES_WAGERING_GAMES_NAV_ITEM_SCCOM,
} from './navigation';
import GameGridItemSCCOM from '../AppSCCOM/components/Game/GameGridItem/GameGridItem';
import GameIframeSCCOM from '../AppSCCOM/components/Game/GameRun/Iframe';
import GameDirectRunSCCOM from '../AppSCCOM/components/Game/GameRun/GameDirectRun';
import SpecialOfferSCCOM from '../AppSCCOM/pages/SpecialOffer/SpecialOfferAsync';
import SpecialOffersSCCOM from '../AppSCCOM/pages/SpecialOffers/SpecialOffersAsync';
import SectionCardsGridSCCOM from '../AppSCCOM/components/SectionCardsGrid/SectionCardsGrid';
import SectionCardSCCOM from '../AppSCCOM/components/SectionCardsGrid/SectionCard/SectionCard';
import SeoPageHeading from '../AppSCCOM/components/SEOWrapper/SeoPageHeading';
import GameLaunchPreviewDesktopSCCOM from '../AppSCCOM/components/GameLaunchPreview/GameLaunchPreviewDesktop/GameLaunchPreviewDesktop';

import { SCCOM_BRAND } from './brands';

export const BASE_LAYOUT = {
  [SCCOM_BRAND]: BaseLayoutAsyncSCCOM,
  default: BaseLayoutAsync,
};

export const MAIN_LIST = {
  [SCCOM_BRAND]: MainAsyncSCCOM,
  default: MainAsync,
};

export const NAVIGATION_LIST = {
  [SCCOM_BRAND]: NavigationAsyncSCCOM,
  default: NavigationAsync,
};

export const MOBILE_GAME_FRAME_HEADER_LIST = {
  [SCCOM_BRAND]: MobileGameFrameHeaderAsyncSCCOM,
  default: MobileGameFrameHeaderAsync,
};

export const GAME_LAUNCH_PREVIEW_MOBILE_LIST = {
  [SCCOM_BRAND]: GameLaunchPreviewMobileSCCOM,
  default: GameLaunchPreviewMobile,
};

export const GAME_LAUNCH_PREVIEW_DESKTOP_LIST = {
  [SCCOM_BRAND]: GameLaunchPreviewDesktopSCCOM,
  default: GameLaunchPreviewDesktop,
};

export const NO_CONTENT_WIDGET_COLLECTION = {
  [SCCOM_BRAND]: NoContentAsyncSCCOM,
  default: NoContentAsync,
};

export const CATEGORY_DETAILS = {
  [SCCOM_BRAND]: CategoryDetailsAsyncSCCOM,
  default: CategoryDetailsAsync,
};

export const RECENT_GAMES_LIST = {
  [SCCOM_BRAND]: RecentGamesAsyncSCCOM,
  default: RecentGames,
};

export const ERROR_PAGE_COLLECTION = {
  [SCCOM_BRAND]: ErrorPageAsyncSCCOM,
  default: ErrorPageAsync,
};

export const COLLECTING_PAGE = {
  [SCCOM_BRAND]: CollectingGamesAsyncSCCOM,
  default: CollectingGamesAsync,
};

export const SEARCH_PAGE = {
  [SCCOM_BRAND]: SearchAsyncSCCOM,
  default: SearchAsync,
};

export const WAGERING_GAMES_PAGE = {
  [SCCOM_BRAND]: WageringGamesAsyncSCCOM,
  default: WageringGamesAsync,
};

export const SPECIAL_OFFER_PAGE_COLLECTION = {
  [SCCOM_BRAND]: SpecialOfferSCCOM,
  default: SpecialOffer,
};

export const SPECIAL_OFFERS_PAGE = {
  [SCCOM_BRAND]: SpecialOffersSCCOM,
  default: SpecialOffers,
};

export const GAME_ITEM_SKELETON_COLLECTION = {
  [SCCOM_BRAND]: GamesSkeletonItem,
  default: GameGridItemSkeleton,
};

export const WAGERING_NAV_ITEM_COLLECTION = {
  [SCCOM_BRAND]: BONUSES_WAGERING_GAMES_NAV_ITEM_SCCOM,
  default: BOUSES_WAGERING_GAMES_NAV_ITEM,
};

export const SEO_WRAPPER_COLLECTION = {
  [SCCOM_BRAND]: SEOWrapperSCCOM,
  default: SEOWrapper,
};

export const GAME_GRID_ITEM_COLLECTION = {
  [SCCOM_BRAND]: GameGridItemSCCOM,
  default: GameGridItem,
};

export const GAME_DIRENT_RUN_COLLECTION = {
  [SCCOM_BRAND]: GameDirectRunSCCOM,
  default: GameDirectRun,
};

export const GAME_IFRAME_COLLECTION = {
  [SCCOM_BRAND]: GameIframeSCCOM,
  default: GameIframe,
};

export const SECTION_CARDS_GRID_COLLECTION = {
  [SCCOM_BRAND]: SectionCardsGridSCCOM,
  default: SectionCardsGrid,
};

export const SECTION_CARD_COLLECTION = {
  [SCCOM_BRAND]: SectionCardSCCOM,
  default: SectionCard,
};

export const PAGE_TITLE_HEADING = {
  [SCCOM_BRAND]: SeoPageHeading,
  default: 'h1',
};

export const GAME_PAGE = {
  [SCCOM_BRAND]: GameAsyncSCCOM,
  default: GameAsync,
};
